import type { ModelSuggestion } from '#/shared/api/generated/shipment/models'

/** At/above this confidence, fill the Type field silently. */
export const TYPE_AUTOFILL_CONFIDENCE = 0.9
/** Between this and the auto-fill threshold, pre-fill but flag it as a guess. */
export const TYPE_SUGGEST_CONFIDENCE = 0.5

export type TypeSuggestionMode = 'autofill' | 'suggest' | 'skip'

/**
 * Decide how assertively to apply the `/vehicles/models` type guess. The body
 * type is a best-guess default — one make/model spans many types — so the
 * suggestion's confidence drives whether we fill silently, fill-and-flag, or
 * stay out of the user's way. See `vehicle-type-frontend-handoff`.
 */
export function resolveTypeSuggestion(
  type: ModelSuggestion['type'],
  confidence: ModelSuggestion['type_confidence'],
): TypeSuggestionMode {
  if (!type || confidence == null) return 'skip'
  if (confidence >= TYPE_AUTOFILL_CONFIDENCE) return 'autofill'
  if (confidence >= TYPE_SUGGEST_CONFIDENCE) return 'suggest'
  return 'skip'
}
